import { FC } from "react";
import { Link } from "react-router-dom";
import './footer.css'

export const Footer:FC<any> = (props):JSX.Element => {

    return (
        <div className="footer__wrapper">
            <span>Powered by <span style={{fontSize:'0.85rem',fontWeight:'bold'}}><Link style={{color:'black'}} to={{pathname:"https://www.lisdatasolutions.com/es/"}}>LIS Data Solutions</Link></span></span>
        </div>
    )
    
}